// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAnyInvalid(validations: any[]): boolean {
  return validations.some((item) => item === undefined || item?.validation);
}
